import Utils from '../shared/Utils';

export default class ProfessorHelpers {
  static genericPostCall(link, data, callback_func, callback_error) {
    if (callback_error == null) {
      callback_error = () => {};
    }

    window.reactFinishedRendering = false;
    return Utils.requestHelper({
      type: 'POST',
      url: link,
      data,
      success: function(response) {
        window.reactFinishedRendering = true;
        Utils.showNotification(response, 'success');
        callback_func();
      },
      error: function(errorResponse) {
        window.reactFinishedRendering = true;
        if (errorResponse && errorResponse.data) {
          Utils.showNotification(errorResponse.data, 'error');
        }
        callback_error();
      }
    });
  }

  static submitGrade(link, data, on_success, on_failure) {
    window.reactFinishedRendering = false;

    return Utils.requestHelper({
      type: 'POST',
      url: link,
      data,
      success: function(response) {
        window.reactFinishedRendering = true;
        const grade = JSON.parse(response.grade);
        Utils.showNotification(response.msg, 'success');
        return on_success(grade);
      },
      error: function(errorResponse) {
        window.reactFinishedRendering = true;
        if (errorResponse && errorResponse.data) {
          Utils.showNotification(errorResponse.data, 'error');
        }
        return on_failure();
      }
    });
  }

  static moveStudents(exam_name, selected_students, callback_func, error_callback) {
    if (!exam_name || !exam_name.length) {
      error_callback();
      return Utils.showNotification(Utils.t('moving_students.please_pick'), 'error');
    }

    const ids = selected_students.map(obj => obj.id);
    const idsAsString = ids.toString();
    return Utils.requestHelper({
      type: 'POST',
      url: '/students/move_in_bulk',
      data: {
        ids: idsAsString,
        exam_name
      },
      success: function(response) {
        Utils.showNotification(response, 'success');
        return callback_func(exam_name);
      },
      error: function(errorResponse) {
        error_callback();
        return Utils.showNotification(errorResponse.data, 'error');
      }
    });
  }

  static deleteSelectedStudents(selected_students, callback_func) {
    const ids = selected_students.map(obj => obj.id);
    const idsAsString = ids.toString();
    return Utils.requestHelper({
      type: 'POST',
      url: '/students/delete_in_bulk',
      data: {
        ids: idsAsString
      },
      success: function(response) {
        Utils.showNotification(response, 'success');
        return callback_func();
      },
      error: function(errorResponse) {
        return Utils.showNotification(errorResponse.data, 'error');
      }
    });
  }

  static addStudent(link, first_name, last_name, academic_year, exam_name, callback_func) {
    if (first_name === '' || last_name === '' || academic_year === '' || exam_name === '') {
      return Utils.showNotification(Utils.t('students.fill_in_values'), 'error');
    }

    window.reactFinishedRendering = false;
    return Utils.requestHelper({
      type: 'POST',
      url: link,
      data: {
        'first_name': first_name,
        'last_name': last_name,
        'year': academic_year,
        'exam_name': exam_name
      },
      success: function(response) {
        window.reactFinishedRendering = true;
        const student = JSON.parse(response.student);
        Utils.showNotification(response.msg, 'success');
        return callback_func(student);
      },
      error: function(errorResponse) {
        window.reactFinishedRendering = true;
        return Utils.showNotification(errorResponse.data, 'error');
      }
    });
  }

  static getProfileInfo(link, callback_func, errorCallback) {
    return Utils.requestHelper({
      type: 'GET',
      url: link,
      success: function(response) {
        const grades = JSON.parse(response.grades);
        return callback_func(grades);
      },
      error: function(errorResponse) {
        Utils.showNotification(errorResponse.data, 'error');
        return errorCallback();
      }
    });
  }

  static editStudentProfile(link, first_name, last_name, year, callback_func) {
    return Utils.requestHelper({
      type: 'POST',
      url: link,
      data: {
        'first_name': first_name,
        'last_name': last_name,
        'year': year
      },
      success: function(response) {
        const student = JSON.parse(response.student);
        Utils.showNotification(response.msg, 'success');
        return callback_func(student);
      },
      error: function(errorResponse) {
        return Utils.showNotification(errorResponse.data, 'error');
      }
    });
  }

  static fillOutParticipatingForm(link, answer, errorCallback) {
    return Utils.requestHelper({
      type: 'POST',
      url: link,
      data: {
        'answer': answer
      },
      success: function(response) {
        Utils.showNotification(response, 'info');
        return Utils.delayedRedirect(location.toString(), 1000);
      },
      error: function(data) {
        Utils.showNotification(response, 'error');
        return errorCallback();
      }
    });
  }

  static deleteProfile(url, impersonating_check, error_callback) {
    return Utils.requestHelper({
      type: 'POST',
      url,
      success: function() {
        Utils.showNotification(Utils.t('delete_profile.success'), 'success');

        if (impersonating_check) {
          return Utils.delayedRedirect('/admin');
        } else {
          return Utils.requestHelper({
            type: 'GET',
            url: '/home/logout',
            success: function() {
              return Utils.delayedRedirect('/home');
            }
          });
        }
      },
      error: function(errorResponse) {
        error_callback();
        return Utils.showNotification(errorResponse.data, 'error');
      }
    });
  }

  static saveHistoricalRecords(updated_historical_records, error_callback) {
    return Utils.requestHelper({
      type: 'POST',
      url: '/admin/edit_historical_records',
      data: {
        records: updated_historical_records
      },
      success: function(response) {
        Utils.showNotification(response, 'success');
        return Utils.delayedRedirect(location.toString());
      },
      error: function(errorResponse) {
        Utils.showNotification(errorResponse.data, 'error');
        return error_callback();
      }
    });
  }
};
